'use strict';

var _regeneratorRuntime = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _awaitAsyncGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var Big = require('bignumber.js');

var parseDuration = require('parse-duration');

var errCode = require('err-code');

function getBandwidthStats(libp2p, opts) {
  var stats;

  if (opts.peer) {
    stats = libp2p.metrics.forPeer(opts.peer);
  } else if (opts.proto) {
    stats = libp2p.metrics.forProtocol(opts.proto);
  } else {
    stats = libp2p.metrics.global;
  }

  if (!stats) {
    return {
      totalIn: new Big(0),
      totalOut: new Big(0),
      rateIn: new Big(0),
      rateOut: new Big(0)
    };
  }

  var _stats = stats,
      movingAverages = _stats.movingAverages,
      snapshot = _stats.snapshot;
  return {
    totalIn: snapshot.dataReceived,
    totalOut: snapshot.dataSent,
    rateIn: new Big(movingAverages.dataReceived[60000].movingAverage() / 60),
    rateOut: new Big(movingAverages.dataSent[60000].movingAverage() / 60)
  };
}

module.exports = function (_ref2) {
  var libp2p = _ref2.libp2p;
  return /*#__PURE__*/function () {
    var _ref = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(options) {
      var interval, timeoutId;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              options = options || {};

              if (options.poll) {
                _context.next = 5;
                break;
              }

              _context.next = 4;
              return getBandwidthStats(libp2p, options);

            case 4:
              return _context.abrupt("return");

            case 5:
              interval = options.interval || 1000;
              _context.prev = 6;
              interval = typeof interval === 'string' ? parseDuration(interval) : interval;

              if (!(!interval || interval < 0)) {
                _context.next = 10;
                break;
              }

              throw new Error('invalid poll interval');

            case 10:
              _context.next = 15;
              break;

            case 12:
              _context.prev = 12;
              _context.t0 = _context["catch"](6);
              throw errCode(_context.t0, 'ERR_INVALID_POLL_INTERVAL');

            case 15:
              _context.prev = 15;

            case 16:
              if (!true) {
                _context.next = 23;
                break;
              }

              _context.next = 19;
              return getBandwidthStats(libp2p, options);

            case 19:
              _context.next = 21;
              return _awaitAsyncGenerator(new Promise(function (resolve) {
                timeoutId = setTimeout(resolve, interval);
              }));

            case 21:
              _context.next = 16;
              break;

            case 23:
              _context.prev = 23;
              clearTimeout(timeoutId);
              return _context.finish(23);

            case 26:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[6, 12], [15,, 23, 26]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};